import { LineEndingType } from "@evergis/api";
import { Coordinates } from "@evergis/sgis/es/baseTypes";
import { FillStyle, PolyRender } from "@evergis/sgis/es/renders/Poly";

import { LineMiterRender } from "./LineMiterRender";

export class ArrowLineMiterRender extends LineMiterRender {
  get usageSize() {
    return this.miterSize + this.strokeWidth;
  }

  createRings([x, y]: Coordinates, xMultiplier: number): Coordinates[][] {
    return [
      [
        [x, y + this.miterSize / 2],
        [x + this.miterSize * xMultiplier, y],
        [x, y - this.miterSize / 2],
      ],
    ];
  }

  createRender(miterRings: Coordinates[][]) {
    const isFilled = this.kind === LineEndingType.FilledArrow;

    return new PolyRender(miterRings, {
      enclosed: isFilled,
      fillColor: isFilled ? this.color : void 0,
      fillStyle: isFilled ? FillStyle.Color : FillStyle.None,
      lineCap: "square",
      lineJoin: "miter",
      strokeColor: this.color,
      strokeWidth: this.strokeWidth,
    });
  }
}
